<template>
  <div id="downloads">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <div class="main">
      <div class="main_new">
        <div class="h2"><img src="../../assets/downloads/icoImg.png">
          <p>启德考培在线<span>线上学习平台</span></p>
        </div>
        <ul class="dzfs">
          <li>
            <img src="https://lximg.eiceducation.com.cn/img/092bdce2c09e4adc84b2c64ea46b72b1" class="qimg" />
            <strong><img src="../../assets/downloads/ios.png" style="margin-right: 5px;"><span>IOS 下载</span></strong>
          </li>
          <li>
            <img src="https://kpimg.eiceducation.com.cn/school_img/09e016110a4e43ce96291591f102d7f4" class="qimg" />
            <strong><img src="../../assets/downloads/Android.png"><span>Android 下载</span></strong>
          </li>
        </ul>
        <div class="imgBig1"><img src="../../assets/downloads/img1.png" /></div>
        <div class="imgBig2"><img src="../../assets/downloads/img2.png" /></div>
      </div>
      <div class="main_new main_new2">
        <div class="h22"><img src="../../assets/downloads/icoImg2.png">
          <p>启德GRE核心词APP<span>只背考试词</span></p>
        </div>
        <ul class="dzfs dzfs2">
          <!-- <li>
            <img src="../../assets/downloads/IOS2.png" class="qimg" />
            <strong><img src="../../assets/downloads/ios.png" style="margin-right: 5px;"><span>IOS 下载</span></strong>
          </li>
          <li>
            <img src="../../assets/downloads/Android2.png" class="qimg" />
            <strong><img src="../../assets/downloads/Android.png"><span>Android 下载</span></strong>
          </li> -->
          <li>
            <img src="../../assets/downloads/greTyong.png" class="qimg" />
            <strong><span>扫一扫，轻松下载</span></strong>
          </li>
        </ul>
        <div class="imgBig3"><img src="../../assets/downloads/img3.png" /></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header.vue'; //公共头部
  export default {
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,
    },
    metaInfo() {
      return {
        title: '客户端下载',
        meta: [{
            name: "keywords",
            content: "启德考培在线,启德考培在线下载"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          },
        ],
      };
    },
    data() {
      return {
        ewms: true,
      }
    },
    methods: {
      ios(index) {
        // console.log(index)
        if (index == 1) {
          this.ewms = true
        } else {
          this.ewms = false
        }
      }
    },
    mounted: function() {}
  }
</script>

<style scoped>
  .bottombox {
    position: relative;
    z-index: 9;
  }

  .main {
    background: url(../../assets/downloads/bj.png) top no-repeat;
    background-size: 1920px auto;
  }

  .main_new {
    width: 1200px;
    height: 752px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
  }

  .main_new2 {
    border-top: 1px #ECECEC dotted;
  }

  .main_new .imgBig1 {
    width: 410px;
    height: 582px;
    position: absolute;
    right: 170px;
    top: 150px;
  }

  .main_new .imgBig2 {
    width: 350px;
    height: 628px;
    position: absolute;
    right: 0px;
    top: 100px;
  }

  .main_new .imgBig1 img,
  .main_new .imgBig2 img,
  .main_new .imgBig3 img {
    display: block;
    width: 100%;
  }

  .main_new2 .imgBig3 {
    width: 596px;
    height: 667px;
    position: absolute;
    left: -45px;
    top: 20px;
  }

  .main_new .h2 {
    width: 479px;
    position: absolute;
    top: 94px;
    left: 0;
  }

  .main_new .h2 img {
    width: 190px;
    float: left;
  }

  .main_new .h2 p {
    width: 228px;
    font-weight: 500;
    font-size: 38px;
    color: #333333;
    line-height: 38px;
    float: left;
    padding-top: 53px;
  }

  .main_new .h2 p span {
    display: block;
    font-weight: 400;
    font-size: 24px;
    color: #666666;
    line-height: 26px;
    padding-top: 10px;
  }

  .main_new .h22 {
    width: 540px;
    position: absolute;
    top: 94px;
    right: 0;
  }

  .main_new .h22 img {
    width: 190px;
    float: left;
  }

  .main_new .h22 p {
    width: 350px;
    font-weight: 500;
    font-size: 38px;
    color: #333333;
    line-height: 38px;
    float: left;
    padding-top: 53px;
  }

  .main_new .h22 p span {
    display: block;
    font-weight: 400;
    font-size: 24px;
    color: #666666;
    line-height: 26px;
    padding-top: 10px;
  }


  .main_new .dzfs {
    width: 484px;
    position: absolute;
    top: 345px;
    left: 30px;
    text-align: center;
  }

  .main_new .dzfs2 {
    right: 30px;
    left: auto;
  }

  .main_new .dzfs li {
    width: 159px;
    float: left;
    margin-right: 55px;
  }

  .main_new .dzfs2 li {
    width: 205px;
    margin: 0 auto;
    float: none;
    /* float: left; */
    /* margin-right: 55px; */
  }

  .main_new .dzfs li .qimg {
    width: 100%;
    margin-bottom: 23px;
  }
  .main_new .dzfs2 li .qimg {
    width: 180px;
    margin-bottom: 12px;
  }


  .main_new .dzfs li strong {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 40px;
    background: #FBFBFB;
    border-radius: 20px 20px 20px 20px;
    border: 1px solid #D8D8D8;
    position: relative;
  }

  .main_new .dzfs li strong img {
    display: block;
    width: 24px;
    height: 24px;
  }


  .main_new .dzfs li strong span {
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 20px;
  }
  .main_new .dzfs2 li strong{
    width: 205px;
  }

  .main_new .ewm {
    width: 180px;
    position: absolute;
    top: 311px;
    right: 0;
    text-align: center;
  }

  .main_new .ewm img {
    width: 180px;
  }

  .main .ewm span {
    display: block;
    font-size: 14px;
    color: #333;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/client/downloads.vue